import { render, staticRenderFns } from "./UnmatchedCard.vue?vue&type=template&id=eab19f12&scoped=true&"
import script from "./UnmatchedCard.vue?vue&type=script&lang=js&"
export * from "./UnmatchedCard.vue?vue&type=script&lang=js&"
import style0 from "./UnmatchedCard.vue?vue&type=style&index=0&id=eab19f12&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab19f12",
  null
  
)

export default component.exports